import React from 'react'
import './Title.css'

const Title = ({ title }) => {
  return (
    <div className="title-header">
      <h2 className="title">{title}</h2>
      <div className="title-line"></div>
    </div>
  )
}

export default Title
